module.exports = __webpack_public_path__ + "static/media/sample2.a51aa56c.png";